<div style="display: flex; align-items: center" class="categoryTags">
    <button mat-icon-button [matMenuTriggerFor]="menu" color="primary" (click)="$event.stopPropagation()">
        <mat-icon>add_box</mat-icon>
    </button>

    <mat-chip-list>
        <mat-chip
            *ngFor="let category of categoriesControl.value"
            disableRipple
            class="catChip catChip-default"
            [class]="cssClass(category.name)"
            [removable]="true"
            (removed)="onCategoryRemoved(category)"
        >
            {{ category.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
    </mat-chip-list>

    <mat-menu #menu="matMenu">
        <mat-selection-list
            #catList
            [compareWith]="compare"
            [formControl]="categoriesControl"
            (click)="$event.stopPropagation()"
            (selectionChange)="$event ? updateCategoryTags($event) : null"
        >
            <mat-list-option *ngFor="let cat of categories" [value]="cat">
                {{ cat.name }}
            </mat-list-option>
        </mat-selection-list>
    </mat-menu>
</div>
